export default __webpack_public_path__ + "static/media/product_test_choices_headset.d69243d5.jpg";